var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98676 23.3003C1.79259 23.3003 0 21.5722 0 19.4556C0 17.3609 1.79259 15.6504 3.98676 15.6504C6.18093 15.6504 7.97352 17.3587 7.97352 19.4556C7.95174 21.592 6.18093 23.3003 3.98676 23.3003ZM3.98676 17.6441C2.93201 17.6441 2.0466 18.4587 2.0466 19.4556C2.0466 20.4941 2.89089 21.3263 3.98676 21.3263C5.06328 21.3263 5.92692 20.5117 5.92692 19.4556C5.90756 18.4587 5.04151 17.6441 3.98676 17.6441Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78816 20.2267C6.13499 20.2267 5.60278 19.7436 5.60278 19.1508V6.23996C5.60278 5.64712 6.13499 5.16406 6.78816 5.16406C7.44134 5.16406 7.97355 5.64712 7.97355 6.23996V19.1508C7.94936 19.7436 7.44134 20.2267 6.78816 20.2267Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2082 20.6175C14.0576 20.6175 12.2989 18.8367 12.2989 16.6564C12.2989 14.476 14.0576 12.6953 16.2082 12.6953C18.3589 12.6953 20.1176 14.476 20.1176 16.6564C20.0958 18.8367 18.3589 20.6175 16.2082 20.6175ZM16.2082 14.7285C15.1728 14.7285 14.3044 15.609 14.3044 16.6564C14.3044 17.7037 15.1728 18.5842 16.2082 18.5842C17.2436 18.5842 18.1121 17.7037 18.1121 16.6564C18.0903 15.609 17.2219 14.7285 16.2082 14.7285Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9322 17.4165C18.279 17.4165 17.7468 16.9335 17.7468 16.3406V1.2341C17.7468 0.64126 18.279 0.158203 18.9322 0.158203C19.5854 0.158203 20.1176 0.64126 20.1176 1.2341V16.3406C20.0934 16.9335 19.5854 17.4165 18.9322 17.4165Z",
    fill: "#B08C3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78815 7.316C6.3527 7.316 5.91725 7.07447 5.72372 6.67924C5.45762 6.15227 5.72372 5.51552 6.30432 5.27399L18.4485 0.267754C19.029 0.0262249 19.7306 0.267752 19.9967 0.794725C20.2628 1.3217 19.9967 1.95845 19.4161 2.19998L7.27198 7.22817C7.10264 7.29405 6.95749 7.316 6.78815 7.316Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicActive);
export default __webpack_public_path__ + "static/media/music-active.b05c0faff75db9f1eff886b71c835d83.svg";
export { ForwardRef as ReactComponent };